// context/AuthContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { API_BASE_URL } from '../config/api.js';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔐 Sprawdź sesję przy starcie
  useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/auth/profile`, {
          credentials: "include",
        });

        if (res.ok) {
          const data = await res.json();
          setUser(data);
        } else {
          setUser(null);
        }
      } catch (err) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  // 🔑 Rejestracja użytkownika
  const handleRegister = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const handleLogin = async (email, password) => {
    const credential = await signInWithEmailAndPassword(auth, email, password);
    const idToken = await credential.user.getIdToken();

    const res = await fetch(`${API_BASE_URL}/api/auth/session-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ idToken }),
    });

    if (!res.ok) throw new Error("Błąd sesji");

    await new Promise((r) => setTimeout(r, 300));

    const profileRes = await fetch(`${API_BASE_URL}/api/auth/profile`, {
      credentials: "include",
    });

    if (profileRes.ok) {
      const profile = await profileRes.json();
      setUser(profile);
    } else {
      throw new Error("Sesja nieaktywna");
    }
  };

  const logout = async () => {
    await fetch(`${API_BASE_URL}/api/auth/logout`, {
      method: "POST",
      credentials: "include",
    });

    await signOut(auth);
    setUser(null);
  };

  // 🧠 Dodaj handleRegister do kontekstu
  return (
    <AuthContext.Provider value={{ user, loading, handleLogin, handleRegister, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
